<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="不可重复消费设置"
      id-key="ConsumeSettingId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="适用餐次" prop="MealId">
          <meal-select v-model="data.MealId" />
        </el-form-item>
        <el-form-item label="间隔时间" prop="TimeLimit">
          <el-input v-model="data.TimeLimit" v-int>
            <span slot="append">秒</span>
          </el-input>
        </el-form-item>
        <div class="row-tb-head">
          <span>设备地点</span>
          <div style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="addPlace">添加</el-button>
          </div>
        </div>
        <el-table class="tb-c-head" :data="data.Places" border>
          <el-table-column label="地点名称" prop="PlaceName" />
          <el-table-column label="操作" align="center" fixed="right" width="60px">
            <template slot-scope="{row,$index}">
              <el-button type="text" @click="delPlace(row,$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="row-tb-head">
          <span>适用人员</span>
          <div style="float: right;">
            <el-dropdown trigger="click" @command="onCommand">
              <el-button type="primary" icon="el-icon-plus">添 加</el-button>
              <el-dropdown-menu slot="dropdown" style="width: 60px;text-align: center;">
                <el-dropdown-item :command="0" style="line-height: 28px;">人员</el-dropdown-item>
                <el-dropdown-item :command="1" style="line-height: 28px;">部门</el-dropdown-item>
                <el-dropdown-item :command="2" style="line-height: 28px;">职务</el-dropdown-item>
                <el-dropdown-item :command="3" style="line-height: 28px;">标签</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <el-table class="tb-c-head" :data="data.Members" border>
          <el-table-column label="人员名称" prop="MemberName" />
          <el-table-column label="类型" prop="MemberType" width="80px">
            <template slot-scope="{row}">
              <span v-if="row.MemberType==0">人员</span>
              <span v-if="row.MemberType==1">部门</span>
              <span v-if="row.MemberType==2">职务</span>
              <span v-if="row.MemberType==3">标签</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="60px">
            <template slot-scope="{row,$index}">
              <el-button type="text" @click="delMember(row,$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <place-dialog ref="placeDialog" in-dialog selectable multiple @select-multiple="setPlace" />
      <teacher-dialog
        ref="teacherDialog"
        in-dialog
        selectable
        multiple
        @select-multiple="setMember"
      />
      <dp-dialog ref="dpDialog" in-dialog selectable multiple @select-multiple="setDp" />
      <job-dialog ref="jobDialog" in-dialog selectable multiple @select-multiple="setJob" />
      <tags-dialog ref="tagsDialog" in-dialog selectable multiple @select-multiple="setTags" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import mealSelect from "@/components/xf/meal/select";
import placeDialog from "@/components/sys/basic/place/listDialog";
import teacherDialog from "@/components/wf/process/teacher/listDialog";
import dpDialog from "@/components/wf/process/dp/listDialog";
import tagsDialog from "@/components/sys/basic/tags/listDialog";
import jobDialog from "@/components/fa/job/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    mealSelect,
    placeDialog,
    teacherDialog,
    dpDialog,
    jobDialog,
    tagsDialog,
  },
  data() {
    return {
      data: {
        ConsumeSettingId: 0,
        MealId: null,
        TimeLimit: null,
        Places: [],
        Members: [],
      },
      DelPlaces: [],
      DelMembers: [],
      api: require("@/api/cp/consumesetting").default,
      rules: {
        MealId: [{ required: true, message: "请选择餐次" }],
        TimeLimit: [{ required: true, message: "请输入时间间隔" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {},
    onEditOpened(data) {
      this.data.Places = this.data.Places.map((x) => ({ ...x, T: null }));
      this.data.Members = this.data.Members.map((x) => ({ ...x, T: null }));
    },
    addPlace() {
      this.$refs.placeDialog.open().then((that) => {
        that.getData();
      });
    },
    setPlace(data) {
      data.forEach((x) => {
        this.data.Places.push({
          ConsumeSettingId: this.data.ConsumeSettingId,
          PlaceId: x.PlaceId,
          PlaceName: x.PlaceName,
          T: 0,
        });
      });
    },
    delPlace(row, index) {
      if (row.T != 0) this.DelPlaces.push({ ...row, T: 2 });
      this.data.Places.splice(index, 1);
    },
    onCommand(e) {
      console.log("onCommand", e);
      switch (e) {
        case 0: //人员
          this.$refs.teacherDialog.open().then((that) => {
            that.getData();
          });
          break;
        case 1: //部门
          this.$refs.dpDialog.open().then((that) => {
            that.getData();
          });
          break;
        case 2: //职务
          this.$refs.jobDialog.open().then((that) => {
            that.getData();
          });
          break;
        case 3: //标签
          this.$refs.tagsDialog.open().then((that) => {
            that.getData();
          });
          break;
      }
    },
    setMember(data) {
      console.log("设置人员", data);
      data.forEach((x) => {
        this.data.Members.push({
          ConsumeSettingId: this.data.ConsumeSettingId,
          MemberId: x.TeacherId,
          MemberName: x.TeacherName,
          MemberType: 0,
          T: 0,
        });
      });
    },
    setDp(data) {
      data.forEach((x) => {
        this.data.Members.push({
          ConsumeSettingId: this.data.ConsumeSettingId,
          MemberId: x.DpId,
          MemberName: x.DpName,
          MemberType: 1,
          T: 0,
        });
      });
    },
    setJob(data) {
      data.forEach((x) => {
        this.data.Members.push({
          ConsumeSettingId: this.data.ConsumeSettingId,
          MemberId: x.JobId,
          MemberName: x.JobName,
          MemberType: 2,
          T: 0,
        });
      });
    },
    setTags(data) {
      data.forEach((x) => {
        this.data.Members.push({
          ConsumeSettingId: this.data.ConsumeSettingId,
          MemberId: x.TagId,
          MemberName: x.TagName,
          MemberType: 3,
          T: 0,
        });
      });
    },
    delMember(row, index) {
      if (row.T != 0) this.DelMembers.push({ ...row, T: 2 });
      this.data.Members.splice(index, 1);
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        if (this.data.Places.length == 0) {
          this.$message.warning("设备地点不能为空");
          return;
        }
        if (this.data.Members.length == 0) {
          this.$message.warning("适用人员不能为空");
          return;
        }

        var data = this.$commonJs.obj.removeNullKey(this.data);

        data.Places = this.data.Places.filter((x) => x.T != null);
        this.DelPlaces.forEach((x) => data.Places.push(x));
        data.Members = this.data.Members.filter((x) => x.T != null);
        this.DelMembers.forEach((x) => data.Members.push(x));

        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.close(true);
            this.$emit("close-saved");
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
  },
};
</script>